import { render, staticRenderFns } from "./ColumnAddressPostCode.vue?vue&type=template&id=6d24ca98"
import script from "./ColumnAddressPostCode.vue?vue&type=script&lang=js"
export * from "./ColumnAddressPostCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports